import { useEffect, useRef, useState, } from "react";

import { useStore } from '../../hook-store/store';

export default function AudioPlayer(props) {
   const { 
    audioUrl, 
    mimeType, 
  } = props;

    const audioPlayer = useRef(null);
    const audioSource = useRef(null);

    const [store, dispatch] = useStore();
    const { paramFileData } = store.uiStore;
    const { mlSpeechCurrentAudioData } = store.mlSpeechStore;

    // Updates src when url changes
    useEffect(() => {
        if (audioPlayer.current && audioSource.current) {
            audioSource.current.src = props.audioUrl;
            audioPlayer.current.load();
        }
    }, [audioUrl, paramFileData]);

    return (
        <div 
          className='flex relative z-10 p-4 w-full'
        >
            {/* {mimeType && mimeType.split('/')[0] ==='audio' && (
              <audio
                  ref={audioPlayer}
                  controls
                  className='w-full h-14 rounded-lg bg-white shadow-xl shadow-black/5 ring-1 ring-slate-700/10'
              >
                  <source ref={audioSource} type={props.mimeType}></source>
              </audio>
            )}
            {mimeType && mimeType.split('/')[0] ==='video' && (
              <div>
                <video
                  style={{maxHeight:"80%", maxWidth: "100%"}}
                    ref={audioPlayer}
                    controls
                    // className='w-full h-14 rounded-lg bg-white shadow-xl shadow-black/5 ring-1 ring-slate-700/10'
                >
                    <source ref={audioSource} type={props.mimeType}></source>
                </video>
              </div>
            )} */}
            {mlSpeechCurrentAudioData && mlSpeechCurrentAudioData.url && mimeType && mimeType.split('/')[0] ==='audio' && (
              <audio
                  ref={audioPlayer}
                  controls
                  className='w-full h-14 rounded-lg bg-white shadow-xl shadow-black/5 ring-1 ring-slate-700/10'
                  src={mlSpeechCurrentAudioData.url}
              >
              </audio>
            )}
            {mlSpeechCurrentAudioData && mlSpeechCurrentAudioData.url && mimeType && mimeType.split('/')[0] ==='video' && (
              <div>
                <video
                    // style={{maxHeight:"80%", maxWidth: "100%"}}
                    style={{maxHeight:"400px", maxWidth: "100%"}}
                    ref={audioPlayer}
                    controls
                    src={mlSpeechCurrentAudioData.url}
                    // className='w-full h-14 rounded-lg bg-white shadow-xl shadow-black/5 ring-1 ring-slate-700/10'
                >
                </video>
              </div>
            )}
        </div>
    );
}
